import { fetchTelegramIdentityRequest } from '../fetch-telegram-identity-request';
import type { ISendTelegramOidcTestDmResponse } from './send-telegram-oidc-test-dm-response';
import { sendTelegramOidcTestDmResponseSchema } from './send-telegram-oidc-test-dm-response';

export async function sendTelegramOidcTestDmApi(): Promise<ISendTelegramOidcTestDmResponse> {
  const response = await fetchTelegramIdentityRequest('/telegram/oidc/test-dm', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!response.ok) {
    throw new Error(`Telegram OIDC test DM failed: ${response.status}`);
  }
  const json = await response.json();
  return sendTelegramOidcTestDmResponseSchema.parse(json);
}
